import React from 'react';
import { Controller } from 'react-hook-form';

const FormSwitch = ({ control, name, id, label }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <label className="switch d-flex align-items-center py-2">
          <input
            id={id}
            type="checkbox"
            checked={field.value} // Using the controlled value
            onChange={field.onChange} // Using the controlled onChange
            onBlur={field.onBlur} // If needed
          />
          <span></span>
          <div className="px-2">{label}</div>
        </label>
      )}
    />
  );
};

export default FormSwitch;
